import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const WebpageIcon = React.memo(function ({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="1" y="12" width="13" height="1" fill={color} />
      <rect x="2.5" y="2.5" width="10" height="8" rx="1" stroke={color} />
      <rect
        x="4"
        y="4"
        width="7"
        height="5"
        rx="0.5"
        fill={color}
        fillOpacity="0.4"
      />
    </svg>
  );
});
